import { AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, AUTH_LOGIN, AUTH_LOGOUT } from "ra-core"
import { AuthProvider } from "ra-core/esm/types"

const isSignedIn = () => {
    const token = localStorage.getItem("auth_token")
    if (token == null) {
        return Promise.reject("not signed in")
    }
    const expiresAt = localStorage.getItem("auth_expires_at")
    if (expiresAt == null) {
        return Promise.reject("no expiry date")
    }
    if (parseInt(expiresAt, 10) < Date.now()) {
        return Promise.reject("token expired")
    }
    return Promise.resolve()
}

const authProvider: AuthProvider = (type, params: any) => {
    // console.log("auth", type, params)
    if (type === AUTH_LOGIN) {
        const auth = params.getAuthResponse()
        localStorage.setItem("auth_token", auth.id_token)
        localStorage.setItem("auth_expires_at", auth.expires_at)
        return isSignedIn()
    }
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem("auth_token")
        localStorage.removeItem("auth_expires_at")
        return Promise.resolve()
    }
    if (type === AUTH_ERROR) {
        return Promise.resolve()
    }
    if (type === AUTH_CHECK) {
        return isSignedIn()
    }
    if (type === AUTH_GET_PERMISSIONS) {
        return isSignedIn()
    }
    return Promise.reject("unknown auth")
}

export default authProvider
